
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaperPlane, faRedoAlt, faCloudUploadAlt, faPenSquare, faMemoPad, faArrowDownToLine } from '@fortawesome/pro-solid-svg-icons'

library.add(faPaperPlane, faRedoAlt, faCloudUploadAlt, faPenSquare, faMemoPad, faArrowDownToLine);